import {isNullOrUndefined} from 'src/app/shared/TerraUtils';


export class CommitmentsUiState {
  [key: string]: boolean;

  constructor() {
    this.hideCommitmentsColumns = false;
  }
  static fromJson(obj: any): CommitmentsUiState {
    const model = new CommitmentsUiState();

    model.hideCommitmentsColumns = !isNullOrUndefined(obj.hideCommitmentsColumns) ? obj.hideCommitmentsColumns : false;

    return model;
  }
}
